import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'


export default function PageComingSoon() {
	const comingSoon = find("[js-page='comingSoon']")
	if (!comingSoon) return


	

	const comingSoonFormSubmit = document.querySelector('#newsletter-form')

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message
		showToastify(message)
		comingSoonFormSubmit.reset()
		setTimeout(enabledBtn, 1000)
	}

	const btnSubmit = document.querySelector('#newsletter-form button[type=submit]')

	function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
	}

	comingSoonFormSubmit &&
		comingSoonFormSubmit.addEventListener('submit', function (event) {
			event.preventDefault()
			disabledBtn()

			const formData = new FormData()
			
			const email = document.querySelector('#newsletter-form input[name=email]').value
			const body =  JSON.stringify({ email: email })

			const url = '/newsletter/'
			axios
				.post(url, body)
				.then((response) => showMessage(response))
				.catch((response) => showMessage(response))
		})
}
